<template>
  <v-autocomplete
    v-model="device_serial"
    :label="label"
    :items="deviceOptions"
    item-text="name"
    item-value="name"
    :search-input.sync="deviceSearch"
    @input.native="loadDevices(false, true)"
    color="primary"
    autocomplete="off"
    persistent-hint
    :rules="rules"
    :disabled="disabled"
    clearable
    :hint="hint"
    :loading="loading"
    no-filter
    return-object
  >
    <template v-slot:item="{ item }">
      <span v-if="item.special">
        <v-icon :color="item.disabled ? 'grey lighten-1' : ''" class="mr-2"
          >mdi-qrcode-plus</v-icon
        >
        {{ item.name }}
      </span>
      <span v-else>
        {{ item.name }}
      </span>
      <v-spacer></v-spacer>
      <!-- <licence-chip
        v-if="item.special"
        :feature="generateVirutalDeviceHandler(item.crm_group)"
        :enabled="generateVirutalDeviceHandler(item.crm_group).enabled"
        float-direction="right"
      ></licence-chip> -->
    </template>
  </v-autocomplete>
</template>

<script>
import api from "@/utils/api";
import debounce from "@/plugins/debounce";
import restrictions from "@/utils/restrictions";
// import LicenceChip from "@/components/general/LicenceChip";
import { mapGetters } from "vuex";
import snackbar from "@/utils/snackbar";

export default {
  name: "DeviceSelector",
  components: {
    // LicenceChip,
  },
  props: {
    deviceSerial: {
      type: String,
      default: String,
    },
    initialData: {
      type: Object,
      default: Object,
    },
    rules: {
      type: Array,
      default: Array,
    },
    disabled: {
      type: Boolean,
      default: Boolean,
    },
    label: {
      type: String,
      default: function () {
        return this.$t("components.selectors.deviceSelector.sentinelSN");
      },
    },
    hint: {
      type: String,
      default: function () {
        return this.$t("components.selectors.deviceSelector.required");
      },
    },
  },
  data: () => ({
    deviceOptions: [],
    deviceSearch: "",
    loading: false,
    timeout: null,
  }),
  created() {
    this.loadDevices(true, true).then((resp) => {
      if (restrictions.canUseCrmFeature("can_create_virtual_device")) {
        this.getDeviceOpitons();
      }
      // this.getDeviceOpitons();

      if (this.initialData && typeof this.initialData.name !== "undefined") {
        this.deviceOptions.push(this.initialData);
        this.device_serial = this.initialData.name;
      }
      this.deviceOptions = [...this.deviceOptions, ...resp];
    });
  },
  computed: {
    device_serial: {
      get: function () {
        if (typeof this.deviceSerial === "string") {
          return this.deviceSerial;
        }
        return "";
      },
      set: function (value) {
        if (typeof value === "undefined") {
          this.$emit("update:deviceSerial", null);
          return;
        }

        if (
          typeof value.id !== "undefined" &&
          value.id === "generateNewVirtualDevice" &&
          Object.keys(this.getMe).length !== 0 &&
          restrictions.canUseCrmFeature("can_create_virtual_device")
        ) {
          this.generateVirtualDevice();
        } else {
          //TODO: Do the refactoring
          if (typeof value.name === "undefined") {
            this.$emit("update:deviceSerial", value);
          } else {
            this.$emit("update:deviceSerial", value.name);
          }
        }
      },
    },
    ...mapGetters(["getMe", "getBrandID", "generateVirutalDeviceHandler"]),
  },
  methods: {
    getDeviceOpitons() {
      this.deviceOptions = [
        {
          id: "generateNewVirtualDevice",
          name: this.$t(
            "components.selectors.deviceSelector.generateNewVirtualDevice"
          ),
          special: true,
          disabled: !restrictions.canUseCrmFeature("can_create_virtual_device"),
        },
      ];
    },
    generateVirtualDevice() {
      this.loading = true;
      let getSuperGroupUuid = this.getMe.crm_groups
        .filter((group) => group.is_supergroup)
        .map((group) => group.uuid);

      if (getSuperGroupUuid.length !== 1) {
        this.$emit("update:deviceSerial", undefined);
        snackbar.error();
      }

      api
        .generateVirtualDevice(getSuperGroupUuid[0])
        .then((resp) => {
          this.deviceOptions.push(resp.data);
          this.$emit("update:deviceSerial", resp.data.name);
          this.loading = false;
        })
        .catch((err) => {
          this.$emit("update:deviceSerial", undefined);
          this.loading = false;
        });
    },
    loadDevices(initalLoad = false, loadAllAvailableDevices) {
      let fetchDevices = () => {
        return new Promise((resolve, reject) => {
          const deviceSearch = loadAllAvailableDevices ? this.deviceSearch : "";

          api.devicesAutocomplete(deviceSearch).then((resp) => {
            this.deviceOptions = resp.data.results;
            resolve(resp.data.results);
          });
        });
      };

      if (initalLoad) return fetchDevices();

      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        return fetchDevices();
      }, 300); // delay
    },
  },
};
</script>
